import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import CreditCardCSVUploadModal from '../../../components/Modal/CreditCardCSVUpload/CreditCardCSVUploadModal';
import { fileDownloadLink } from '../../../resources/functions';
import { useChartAccountApi } from '../../../resources/hooks/api/chartAccountApiHook';
import { getBranch } from '../../../store/user/selectors';

// import '../GlClassification.css'
import SAlert from '../../../components/SAlert';
import SelectCustomOption from '../../../components/SelectCustomOption';
import { GL_VP, SELECT_CUSTOM_STYLE } from '../../../resources/constants';
import { useCreditCardApi } from '../../../resources/hooks/api/creditCardApiHook';

interface Props {

}

const CreditCardGlClassificationStatus: React.FC<Props> = () => {
    const { t } = useTranslation("scenes.glclassification.credit_card");
    const { fetchCreditCardCsvList, CCDelete } = useCreditCardApi();
    const { glAccountsList } = useChartAccountApi();
    const navigate = useNavigate();

    const branchData = useSelector(getBranch)

    const [records, setRecords] = useState<any | null>(null);
    const [isVisibleCsvUploader, setIsVisibleCsvUploader] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [page, setPage] = useState(1);
    const [searchParam, setSearchParam] = useState<any>({
        master_chart_of_account_id: null,
        status: null
    });
    const [totalRecords, setTotalRecords] = useState(1);
    const [selectCustomStyle, setSlectCustomStyle] = useState<any>(SELECT_CUSTOM_STYLE('#fff'));
    const [ showConfirm, setShowConfirm ] = useState<boolean>(false);
    const [ selectedRecordId, setSelectedRecordId ] = useState<number | null>(null);

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    useEffect(() => {
        fetchList();
    }, [page])

    const fetchList = () => {
        setIsLoading(true);
        const params: any = {
            branch_id: branchData['id'],
            page: page,
            per_page: 10
        }
        if (searchParam['master_chart_of_account_id']) {
            params['master_chart_of_account_id'] = searchParam['master_chart_of_account_id']
        }
        if (searchParam['status'] !== null) {
            params['status'] = searchParam['status']
        }
        fetchCreditCardCsvList(params, (message: string, resp: any) => {
            setIsLoading(false);
            setRecords(resp.data.data.items);
            setTotalRecords(resp.data.data.total);
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const fechAccountList = (searchText: string = ''): Promise<any[]> => {
        return new Promise<any>((resolve, reject) => {
            const params: any = {
                "page": 1,
                "per_page": 10,
                branch_id: +branchData['id']
            }
            if (searchText) {
                params['name'] = searchText;
            }
            params['parent_account_in'] = GL_VP.CREDIT_CARD.account.join(',');

            glAccountsList(params, (message: string, resp: any) => {
                const data = resp.data.data.result.map((e: any) => ({
                    label: e['name'] + `(${e['account']})`,
                    value: e['id'],
                    account: e['account']
                }));
                return resolve(data);
            }, (message: string, resp: any) => {
                toast.error(message);
                return resolve([]);
            })
        })
    }

    const filterAccountList = async (inputValue: string) => {
        const data = await fechAccountList(inputValue)
        return data;
    };

    const _handleDownloadCsv = (url: string, fileName: string) => {
        fileDownloadLink(url, fileName);
    }

    const hideCsvUploader = () => {
        setIsVisibleCsvUploader(false);
        fetchList();
    }

    const _handleChangeSearchParam = (name: string, e: any) => {
        console.log('e: ', e)
        setSearchParam({
            ...searchParam,
            [name]: e ? e.value : null
        })
    }

    const _handleConfirm = (id: number) => {
        setShowConfirm(true);
        setSelectedRecordId(id);
    }

    const _handleDeleteRecord = () => {
        setIsLoading(true);
        CCDelete({ id: selectedRecordId, branch_id: branchData.id}, (message: string, resp: any) => {
            toast.success(message);
            setShowConfirm(false);
            setIsLoading(false);
            fetchList();
        }, (message: string, resp: any) => {
            toast.error(message);
            setIsLoading(false);
        })
    }

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="pb-3 pt-3" id="ux_page_title">
                    <div className="align-items-center d-flex justify-content-between">
                        <div className="align-items-center d-flex page-title">
                            <h1 className="h5 font-weight-700 mb-0 d-inline-flex">{t('status.title')}</h1>
                        </div>
                      
                          <div className="d-flex align-items-center gap-2">
                              <div className="">
                            <button type="button" className="btn btn-primary" onClick={() => setIsVisibleCsvUploader(true)}>{t('button.upload_csv')}</button>
                                </div>
                                    <div className="filter-box">
                                        <AsyncSelect
                                            isClearable={true}
                                            placeholder={t('dropdown.placeholder.account')}
                                            defaultOptions
                                            loadOptions={filterAccountList}
                                            className={'zindex-10'}
                                            menuPosition='fixed'
                                            onChange={(e: any) => _handleChangeSearchParam('master_chart_of_account_id', e)}
                                            styles={selectCustomStyle}
                                            components={{ Option: SelectCustomOption }}
                                        />
                                    </div>
                                    <div className="filter-box">
                                        <Select
                                            isClearable={true}
                                            options={[
                                                { label: t('status.pending'), value: 0 },
                                                { label: t('status.classified'), value: 1 }
                                            ]}
                                            placeholder={t('dropdown.placeholder.status')}
                                            className={'zindex-10'}
                                            menuPosition='fixed'
                                            onChange={(e: any) => _handleChangeSearchParam('status', e)}
                                            styles={selectCustomStyle}
                                            components={{ Option: SelectCustomOption }}
                                        />
                                    </div>

                                    <div className="filter-btn">
                                        <button type="button" onClick={() => fetchList()}>{t('button.search')} &nbsp; <i className="fa fa-search" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                    </div>
                </div>
                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                            <div className="loader"></div>
                        </div>
                        <div className="table-responsive list-table table-scroll"
                        style={{ maxHeight: 'calc(100vh - 240px)', overflowY: 'auto' }}
                        >
                            <table className="table table-default">
                                <thead>
                                    <tr className="align-middle">
                                        <th className="text-center">{t('table.date_uploaded')}</th>
                                        <th className="text-center">{t('table.credit_acc')}</th>
                                        <th className="text-center">{t('table.csv_file')}</th>
                                        <th className="text-center">{t('table.status')}</th>
                                        <th className="text-center">{t('table.action')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        records && records.map((data: any, index: number) => (
                                            <tr className="align-middle h-40" key={index}>
                                                <td className="text-center">
                                                    {moment.utc(data['created_at']).local().format('Do MMM, YYYY')}
                                                </td>
                                                <td className="text-center">
                                                    {data['name'] + ' (' + data['account'] + ')'}
                                                </td>
                                                <td className="text-center">
                                                    {data['file_name']} &nbsp;
                                                    <i className="fa fa-download cursor-pointer" title={t('button.download')} onClick={() => _handleDownloadCsv(data['file_path'], data['file_name'])}></i>
                                                </td>
                                                <td className="text-center">
                                                    <h6>
                                                        {data['status'] == 0 ? <Badge bg="warning" className='p-2'>{t('status.pending')}</Badge> : <Badge bg="success">{t('status.classified')}</Badge>}
                                                    </h6>
                                                </td>
                                                <td className="text-center">
                                                    {/* {
                                                        data['status'] == 0 && <Link to={`/credit-card-gl-classification/${data.id}`}>Click Here To Classify</Link> || <Link to={`/credit-card-gl-classification/${data.id}`}>View Table</Link>
                                                    } */}
                                                    {
                                                        data['status'] == 0 && 
                                                        (<button type='button' className='btn btn-primary btn-sm' onClick={() => navigate(`/credit-card-gl-classification/${data.id}`)}>{t('button.classify')}</button>) || <></>
                                                        // (<button disabled={data['status'] == 1} type='button' className='btn btn-primary btn-sm' onClick={() => navigate(`/credit-card-gl-classification/${data.id}`)}>View Table</button>)
                                                    }
                                                    &nbsp;
                                                    <button type='button' className='btn btn-danger btn-sm' onClick={() => _handleConfirm(data.id)}>{t('button.remove')}</button>
                                                </td>
                                                <td></td>
                                            </tr>))
                                    }
                                    {
                                        records && records.length == 0 && (
                                            <tr>
                                                <td colSpan={5} className='text-center'>
                                                    <p>{t('empty.no_records')}</p>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <Pagination count={Math.ceil(totalRecords / 10)} page={page} onChange={handleChange} />
                        </div>
                    </div>
                </div>
                {
                    isVisibleCsvUploader && <CreditCardCSVUploadModal closeModal={hideCsvUploader} />
                }
                <SAlert
                    show={showConfirm}
                    icon={'warning'}
                    showCancel={true}
                    confirmBtnText={t('button.delete')}
                    cancelBtnText={t('button.no')}
                    confirmBtnBsStyle={'danger'}
                    cancelBtnBsStyle={"secondary"}
                    title={t('modal.confirm_delete.title')}
                    msg={t('modal.confirm_delete.message')}
                    onConfirm={() => _handleDeleteRecord()}
                    onCancel={() => setShowConfirm(false)}
                />
            </div>
        </div>

    )
}

export default CreditCardGlClassificationStatus;